export default __webpack_public_path__ + "static/media/course1.591d21eb.webp";